'use client';

import MenuTitle from "@/app/components/menuTitle";
import Lms from "./lms";
import { useEffect } from "react";
import { useTitleStore } from "@/stores";

const Page: React.FC = () => {
  const {setSelectedTitle} = useTitleStore();

  useEffect(() => {
    setSelectedTitle("LMS > BLACKBOARD")
  }, [])
    return (
      <div>
        <MenuTitle/>
        <Lms/>
      </div>
    );
  };
  
  export default Page;
  
  